<script>
/**
 * @overview 全局文字单选组件
 *
 * @author huojinzhao
 */

export default {
  name: "VRadioText",

  props: {
    list: {
      type: Array,
      required: true,
    },

    value: {
      type: [String, Number],
      default: null,
    },

    labelKey: {
      type: String,
      default: "label",
    },

    valueKey: {
      type: String,
      default: "value",
    },
  },

  methods: {
    chooseItem(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
};
</script>

<template>
  <div class="v-radio-text">
    <span
      v-for="item in list"
      :key="item[valueKey]"
      :class="{
        'v-radio-text__item': true,
        'v-radio-text__item--active': item[valueKey] === value,
      }"
      @click.stop="() => chooseItem(item[valueKey])"
    >
      {{ item[labelKey] }}
    </span>
  </div>
</template>

<style lang="postcss">
.v-radio-text {
  display: flex;
}

.v-radio-text__item {
  padding: 1em 0;
  text-align: center;
  color: var(--font-color-default);
  cursor: pointer;
}

.v-radio-text__item:not(:last-child) {
  margin-right: 2em;
}

.v-radio-text__item:hover,
.v-radio-text__item--active {
  color: var(--font-color-active);
}
</style>
